import React from 'react';
import { Routes, Route, Link, Navigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import BrandList from './BrandList';
import Brand from './Brand';
import Inventory from './Inventory';
import Analytics from './Analytics';
import Conversations from './Conversations';
import Users from './Users';
import Billing from './Billing';
import Organizations from './Organizations';
import Breadcrumbs from '../../components/Breadcrumbs';
import useCurrentUser from '../../hooks/useCurrentUser';
import './AdminDashboard.scss';

function AdminDashboard() {
    const { logout, user } = useAuth0();
    const { isSuperAdmin } = useCurrentUser();

    return (
        <div className="admin-dashboard">
            {/* Top Navbar */}
            <nav className="navbar navbar-dark bg-lighthouse-gradient">
                <div className="container-fluid">
                    <div className="d-flex align-items-center">
                        <Link to="/" className="navbar-brand">
                            ⚓ Lighthouse Admin
                        </Link>
                        <span className="text-white-50 small ms-2">Dashboard</span>
                    </div>

                    <div className="d-flex align-items-center gap-3">
                        <span className="text-white-50 small d-none d-md-inline">
                            {user?.email}
                        </span>
                        <button
                            className="btn btn-sm btn-outline-light"
                            onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
                        >
                            Logout
                        </button>
                    </div>
                </div>
            </nav>

            <div className="dashboard-container">
                {/* Sidebar */}
                <aside className="dashboard-sidebar bg-light">
                    <nav className="nav flex-column p-3">
                        <Link to="/admin/analytics" className="nav-link">
                            📊 Analytics
                        </Link>
                        <Link to="/admin/brands" className="nav-link">
                            🏢 Brands
                        </Link>
                        <Link to="/admin/conversations" className="nav-link">
                            💬 Conversations
                        </Link>
                        {isSuperAdmin && (
                            <Link to="/admin/organizations" className="nav-link">
                                🏛️ Organizations
                            </Link>
                        )}
                        {isSuperAdmin && (
                            <Link to="/admin/users" className="nav-link">
                                👥 Users
                            </Link>
                        )}
                        {isSuperAdmin && (
                            <Link to="/admin/billing" className="nav-link">
                                💳 Billing
                            </Link>
                        )}
                        <hr />
                        <Link to="/" className="nav-link text-muted">
                            ← Back to Home
                        </Link>
                    </nav>
                </aside>

                {/* Main Content */}
                <main className="dashboard-content">
                    <Breadcrumbs />
                    <Routes>
                        <Route path="" element={<Navigate to="analytics" replace />} />
                        <Route path="analytics" element={<Analytics />} />
                        <Route path="brands" element={<BrandList />} />
                        <Route path="brands/:id" element={<Brand />} />
                        <Route path="brands/:id/inventory" element={<Inventory />} />
                        <Route path="conversations" element={<Conversations />} />
                        <Route path="users" element={<Users />} />
                        <Route path="billing" element={<Billing />} />
                        <Route path="organizations" element={<Organizations />} />
                    </Routes>
                </main>
            </div>
        </div>
    );
}

export default AdminDashboard;
